import { fetchDiscoverySegment } from '../../AiAnalytics/actions/fetchDiscoverySegment';
import { fetchFeedBackListData } from '../../FeedBackList/actions/fetchFeedBackListData';
import { fetchOnlineReviewData } from '../../OnlineReview/actions/fetchOnlineReviewData';
import { fetchOverviewData } from '../../Overview/actions/fetchOverViewData';
import { fetchAlertSummaryDataByType } from '../../Alerts/actions/alertSummaryByType';
import { sections } from '../constants/sectionConstants';
import { fetchRoomRankerConfig } from '../../RoomRanker/actions/fetchRoomRankerConfig';

export const fetchDataWithAppliedFilters = (appliedFilterValues, currentSection, currentSectionConfig) => dispatch => {
  const appliedFiltersForCurrentSection = extractCurrentSectionFilters(appliedFilterValues, currentSectionConfig);
  const { filters, benchmark } = parseFilters(appliedFiltersForCurrentSection);
  switch (currentSection) {
    case sections.ONLINE_REVIEW:
      dispatch(fetchOnlineReviewData({ filters: filters, benchmark: benchmark }));
      break;
    case sections.OVERVIEW:
      dispatch(fetchOverviewData({ filters: filters, benchmark: benchmark }));
      break;
    case sections.FEEDBACK:
      dispatch(fetchFeedBackListData(1, filters));
      break;
    case sections.AI_INSIGHTS:
      dispatch(fetchDiscoverySegment(filters, benchmark));
      break;
    case sections.ALERTS:
      dispatch(fetchAlertSummaryDataByType(filters));
      break;
    case sections.ROOM_RANKER:
      dispatch(fetchRoomRankerConfig());
      break;
  }
};

export const extractCurrentSectionFilters = (appliedFilterValues, currentSectionConfig) => {
  Object.keys(appliedFilterValues).forEach(key => {
    const filterConfig = currentSectionConfig.find(f => f.key === key);
    if (!filterConfig) {
      delete appliedFilterValues[key];
    }
  });
  return appliedFilterValues;
};

export const parseFilters = (applied_filters = {}) => {
  const filters = {};
  const additionalFilters = {};
  let benchmark = null;
  Object.entries(applied_filters).forEach(([key, value]) => {
    const normalizedKey = key.toLowerCase();

    if (normalizedKey === 'timeperiod') {
      if (Array.isArray(value) && value.length > 0) {
        Object.assign(filters, value[0]);
      } else if (typeof value === 'object' && value !== null) {
        Object.assign(filters, value);
      }
      return;
    }

    // if (normalizedKey === 'feedback_source_type') {
    //   if (Array.isArray(value) && value.length > 0) {
    //     additionalFilters[key] = value[0];
    //   }
    //   return;
    // }

    if (normalizedKey === 'alert_status') {
      if (Array.isArray(value) && value.length > 0) {
        additionalFilters[key] = value[0];
      }
      return;
    }

    if (normalizedKey === 'benchmark') {
      if (typeof value[0] === 'string' && value[0] === 'Same Period Year Ago') {
        const startDate = new Date(filters.start_date);
        const endDate = new Date(filters.end_date);

        const benchmarkStart = new Date(startDate);
        benchmarkStart.setFullYear(startDate.getFullYear() - 1);

        const benchmarkEnd = new Date(endDate);
        benchmarkEnd.setFullYear(endDate.getFullYear() - 1);

        benchmark = {
          start_date: benchmarkStart.toISOString().split('T')[0],
          end_date: benchmarkEnd.toISOString().split('T')[0]
        };
        return;
      }
      benchmark = value[0];
      return;
    }

    if (
      value == null ||
      (Array.isArray(value) && value.length === 0) ||
      (Array.isArray(value) && Array.isArray(value[0]) && value[0].length === 0)
    ) {
      return;
    }

    additionalFilters[key] = value;
  });

  if (Object.keys(additionalFilters).length > 0) {
    filters.additional_filters = additionalFilters;
  }

  return { filters, benchmark };
};
